"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: detailsRef,
    isVisible: detailsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const contactBlocks = [{
    label: "HEADQUARTERS",
    content: "1234 Construction Blvd, Garden City, KS 67846"
  }, {
    label: "OPERATING HOURS",
    content: "Mon — Fri / 08:00 — 17:00",
    secondary: "Emergency Services Available 24/7"
  }, {
    label: "GET IN TOUCH",
    content: "LuxuryConstructionInvestments@gmail.com",
    secondary: "(620) 640-0354"
  }];
  return <section data-section-id="2555" id="lets-discuss-your-project" className="dark bg-background text-foreground relative overflow-hidden min-h-[70vh] flex items-center justify-center px-6 py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute -bottom-1/3 -right-1/4 w-[700px] h-[700px] rounded-lg opacity-30" style={{
      background: "radial-gradient(circle, hsl(45 90% 45% / 0.2) 0%, transparent 60%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      <div className="relative z-10 w-full max-w-[1180px] mx-auto">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground mb-10 md:mb-14">
            CONTACT — LUXURY CONSTRUCTION LLC
          </p>

          <h1 className="font-default font-bold text-foreground leading-[0.95] tracking-tight mb-10 md:mb-12" style={{
          fontSize: "clamp(3rem, 9vw, 7rem)"
        }}>
            Let's build your
            <br />
            <span className="italic font-normal text-primary">future</span>{" "}
            together.
          </h1>

          <p className="font-default text-base md:text-[18px] leading-relaxed text-muted-foreground max-w-[540px] mx-auto">
            Whether you need a professional roof inspection or a fast cash offer for your property, our team is ready to provide reliable, expert solutions tailored to your needs.
          </p>
        </div>

        {}
        <div ref={detailsRef} className={`mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 transition-all duration-1000 delay-200 ease-out ${detailsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {contactBlocks.map((block, i) => <div data-index={i} key={block.label} className="flex flex-col items-start text-left">
              {}
              <div className="w-12 h-px bg-primary mb-5" aria-hidden="true" />

              <p className="font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
                {block.label}
              </p>

              <p className="font-default text-[20px] leading-snug text-foreground">
                {block.content}
              </p>

              {block.secondary && <p className="font-default text-[20px] leading-snug text-foreground mt-1">
                  {block.secondary}
                </p>}
            </div>)}
        </div>
      </div>
    </section>;
}